// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Sneakers_wrapper__1K5AZ","title-container":"Sneakers_title-container__yvMUh"};